import { useEffect, useState } from "react";

import size from "lodash/size";
import useAxios from "@src/utility/hooks/use-axios";
import { useParams } from "react-router-dom";

const useConversations = ({ attributes }) => { 
    const { clientId, platformId } = useParams();
    const [data, setData] = useState({
        conversations: [],
        active       : "",
        nextBatch    : 0,
        count        : 0
    });
    const [convDetails, setConvDetails] = useState({});

    const { axiosInstance, loading } = useAxios({ base: "panel", initialLoader: true });
    const { axiosInstance: detailsInstance, loading: detailsLoading } = useAxios({ base: "panel", initialLoader: true });

    const getConversationDetails = async (id) => {
        setData((prev) => ({
            ...prev,
            active: id
        }));
        const { data } = await detailsInstance.get(`/support/${platformId}/conversation/${id}`, {
            params: {
                platform: attributes.platform._id
            }
        });
        setConvDetails(data);

    };

    const getConversations = async () => {
        const { data: { conversations, nextBatch } } = await axiosInstance.get(
            `/support/${platformId}/conversations/${clientId}`,
            {
                params: {
                    batch: data.nextBatch
                }
            }
        );
        if (size(conversations)) setData((prev) => ({
            conversations: Array.from(
                new Map([...prev.conversations, ...conversations].map(item => [item.id, item])).values()
            ),
            active: conversations[0].id,
            count : prev.count + conversations.length,
            nextBatch
        }));
        if (size(conversations)) getConversationDetails(conversations[0].id);
    };

    useEffect(() => {
        if (size(attributes)) {
            getConversations();
        }
    }, [clientId, attributes]);

    return {
        loading,
        getConversationDetails,
        detailsLoading,
        getConversations,
        convDetails,
        data
    };
};

export default useConversations;